import styled from 'styled-components';

export const Container = styled.div<{ anchor: string }>`
  pointer-events: none;
  position: absolute;
  width: 160px;
  padding: 10px;
  background-color: rgba(0, 0, 0, 0.75);
  border-radius: 8px;
  z-index: 999;
  transition:
    300ms opacity,
    300ms transform;

  &:after {
    content: '';
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 8px solid rgba(0, 0, 0, 0.75);
    position: absolute;
    bottom: -8px;
    left: ${(props) => {
      if (props.anchor === 'left') return '10px';
      if (props.anchor === 'right') return '130px';

      return '72px';
    }};
  }
`;

export const Text = styled.p`
  color: white;
  text-align: center;
  font-size: 12px;
  font-weight: 600;
`;
